import React, { useContext } from 'react';
import Button from '@/components/Button';
import isRtl from '@/utils/isRtl';
import { createStyleSheet } from 'jss-theme-reactor';
import { StyleManagerContext } from '@/styles/StyleManagerContext';

// Legacy requires compatible with current asset build
import XIcon from '@/components/icons/XIcon';

export const styleSheet = createStyleSheet('Message', (theme: any) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    message: {
      display: 'inline-block',
      fontSize: 16,
    },
  };
});

interface IMessageProps {
  message: string;
  action?: string;
  actionPayload?: any;
  onAction: (action: string, payload?: any) => void;
  onClose: () => void;
}

const Message: React.FC<IMessageProps> = (props) => {
  const { styleManager } = useContext(StyleManagerContext);
  const classes = styleManager.render(styleSheet);
  
  const { message, action, actionPayload, onAction, onClose } = props;

  return (
    <div className={classes.root}>
      <div></div>
      <div>
        <div className={classes.message}>{message}</div>
        {/* {{ UPDATED TO PASS PAYLOAD }} */}
        {action ? <Button label={action} onClick={() => onAction(action, actionPayload)} /> : null}
      </div>
      <div>
        <Button
          icon={<XIcon pathStyle={{ fill: '#FFFFFF' }} />}
          style={{ padding: 0, width: '38px', height: '38px', margin: isRtl() ? '0 0 0 5px' : '0 5px 0 0' }}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default Message;